import s from "./basket.module.css";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";


const OrderSuccess = () => {
    return (<div className={s.basket}>
            <div className={`${s.basketContent} content`}>
                <Breadcrumbs/>
                <h3>Ваш заказ сформирован!</h3>
                <p>Ваш заказ успешно сформирован!

                    Вы можете просматривать все ваши заказы в Личном кабинете в разделе "История заказов".

                    Спасибо за покупки в нашем интернет-магазине!</p>
            </div>
        </div>
    )
}

export default OrderSuccess;